"use strict";

// Class definition
var KTCardsWidget17 = function () {
    // Private methods
    var initChart = function() {
        var el = document.getElementById('kt_card_widget_17_chart'); 

        if (!el) {
            return;
        }

        var options = {
            size: el.getAttribute('data-kt-size') ? parseInt(el.getAttribute('data-kt-size')) : 70,
            lineWidth: el.getAttribute('data-kt-line') ? parseInt(el.getAttribute('data-kt-line')) : 11,
            rotate: el.getAttribute('data-kt-rotate') ? parseInt(el.getAttribute('data-kt-rotate')) : 145, 
            //percent:  el.getAttribute('data-kt-percent') ,
        }
        var canvas = document.createElement('canvas');
        var span = document.createElement('span'); 
            
        if (typeof(G_vmlCanvasManager) !== 'undefined') {
            G_vmlCanvasManager.initElement(canvas);
        }

        var ctx = canvas.getContext('2d');
        canvas.width = canvas.height = options.size;

        el.appendChild(span);
        el.appendChild(canvas);

        ctx.translate(options.size / 2, options.size / 2); // change center
        ctx.rotate((-1 / 2 + options.rotate / 180) * Math.PI); // rotate -90 deg

        //imd = ctx.getImageData(0, 0, 240, 240);
        var radius = (options.size - options.lineWidth) / 2;

        var drawCircle = function(color, lineWidth, percent) {
            percent = Math.min(Math.max(0, percent || 1), 1);
            ctx.beginPath();
            ctx.arc(0, 0, radius, 0, Math.PI * 2 * percent, false);
            ctx.strokeStyle = color;
            ctx.lineCap = 'square'; // butt, round or square
            ctx.lineWidth = lineWidth
            ctx.stroke();
        };

        var totalMember = 0;

        var memberOneVal = el.getAttribute("data-member-one-perc") ? parseInt(el.getAttribute("data-member-one-perc")) : 20; 
        var memberTwoVal = el.getAttribute("data-member-two-perc") ? parseInt(el.getAttribute("data-member-two-perc")) : 30; 
        var memberThreeVal = el.getAttribute("data-member-three-perc") ? parseInt(el.getAttribute("data-member-three-perc")): 50;
        var totalVal = memberOneVal + memberTwoVal + memberThreeVal;

        console.log(memberOneVal, memberTwoVal, memberThreeVal, totalVal, (memberOneVal + memberTwoVal) / totalVal, memberOneVal / totalVal)

        // Init 
        drawCircle('#E4E6EF', options.lineWidth, totalVal / totalVal);
        drawCircle(KTUtil.getCssVariableValue('--bs-success'), options.lineWidth, (memberOneVal + memberTwoVal) / totalVal);
        drawCircle(KTUtil.getCssVariableValue('--bs-primary'), options.lineWidth, memberOneVal / totalVal);
    }

    // Public methods
    return {
        init: function () {
            initChart();
        }   
    }
}();

// Webpack support
if (typeof module !== 'undefined') {
    module.exports = KTCardsWidget17;
}

// On document ready
KTUtil.onDOMContentLoaded(function() {
    KTCardsWidget17.init();
});
   
        
        
        
           